import { I18n } from '@calendly/i18n'

export const getOptions = () => {
  const mins = I18n.t('time.min_abbr')
  const hr = I18n.t('time.hours_abbr', { count: 1 })

  return [
    { value: '0', name: `0 ${mins}` },
    { value: '5', name: `5 ${mins}` },
    { value: '10', name: `10 ${mins}` },
    { value: '15', name: `15 ${mins}` },
    { value: '30', name: `30 ${mins}` },
    { value: '45', name: `45 ${mins}` },
    { value: '60', name: `1 ${hr}` },
    { value: '90', name: `1 ${hr} 30 ${mins}` },
    { value: '120', name: `2 ${hr}` },
    { value: '150', name: `2 ${hr} 30 ${mins}` },
    { value: '180', name: `3 ${hr}` }
  ]
}
